import { Dispatch } from "redux";
import { createActionCreator, createReducer } from "deox";
import * as necklacesService from "../services/necklaces";
import { CustomNecklace } from "../models/necklaces";

export type State = {
  customNecklaces: CustomNecklace[] | null;
};

const defaultState: State = {
  customNecklaces: null,
};

const fetchCustomNecklaces = Object.assign(
  () => async (dispatch: Dispatch) => {
    try {
      const result = await necklacesService.getAllCustomNecklaces();
      dispatch(fetchCustomNecklaces.success(result));
      console.log(result, "RESULLT")
    } catch {
      return;
    }
  },
  {
    success: createActionCreator("@@NECKLACES/CUSTOM/FETCH", resolve => (data: CustomNecklace[]) => resolve(data)),
  }
);


const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchCustomNecklaces.success, (state, action) => ({ ...state, customNecklaces: action.payload })),
]);

const actions = {
  fetchCustomNecklaces,
};

export { actions, reducer };
